import { type ReactElement, useRef } from 'react';
import { Tooltip } from '@optimization/ssi-common';
import { localizeDate } from '@/utils/date';

interface CalendarAgeCellProperties {
  readonly calendarAgeMonths: number;
  readonly assemblyDate: string;
}

const CalendarAgeCell = ({ calendarAgeMonths, assemblyDate }: CalendarAgeCellProperties): ReactElement | null => {
  const ref = useRef<HTMLSpanElement>(null);

  const years = Math.floor(calendarAgeMonths / 12);
  const months = calendarAgeMonths % 12;

  return (
    <>
      <span ref={ref}>
        {years} <span className="tds-text-grey-350">y</span> {months} <span className="tds-text-grey-350">m</span>
      </span>
      <Tooltip elRef={ref}>
        <span>Assembled: {localizeDate(new Date(assemblyDate))}</span>
      </Tooltip>
    </>
  );
};

export default CalendarAgeCell;
